import { useLazyGetContractsQuery } from '@/api/queries/contract';
import {
  type PaidSpecContractType,
  type SpecContractType,
} from '@/common/types/contract';
import { selectSpecContractExpiredStatusEndDate } from '@/redux/selectors/contractSelectors';
import { useAppSelector } from '@/redux/store';

import { useTimerToEnd } from '../timer-to-end';

const useExpireContractTimer = (
  kind: SpecContractType | PaidSpecContractType,
  callback?: () => void,
): number | null => {
  const expiredStatusEndDate = useAppSelector((state) =>
    selectSpecContractExpiredStatusEndDate(state, kind),
  );

  return useTimerToEnd(expiredStatusEndDate, callback);
};

const useExpireContractRefetch = (
  kind: SpecContractType | PaidSpecContractType,
): number | null => {
  const [getContracts] = useLazyGetContractsQuery();

  return useExpireContractTimer(kind, (): void => {
    getContracts();
  });
};

export { useExpireContractRefetch, useExpireContractTimer };
